<div id="alerts">
  @for (alert of appContext.alerts.slice(0, maxAlertCount); track alert) {
    <div class="mt-2">
      <app-status-alert [type]="alert.level" (close)="appContext.closeAlerts([alert])"
                        [msShowTime]="alert.msShowTime">{{ alert.content }}
      </app-status-alert>
    </div>
  }
  @if (appContext.alerts.length > maxAlertCount) {
    <div class="mt-2">
      <div class="collapse" id="alertsColapse">
        @for (alert of appContext.alerts.slice(maxAlertCount); track alert) {
          <div>
            <app-status-alert [type]="alert.level" (close)="appContext.closeAlerts([alert])"
                              [msShowTime]="alert.msShowTime">{{ alert.content }}
            </app-status-alert>
          </div>
        }
      </div>
      <button class="btn btn-outline-danger float-end collapsed mb-2" type="button" data-bs-toggle="collapse"
              data-bs-target="#alertsColapse">
        <span class="more-alerts-button">Show more errors</span>
        <span class="fewer-alerts-button">Show fewer errors</span>
      </button>
    </div>
  }
</div>
